module.exports = __webpack_public_path__ + "img/icon-implantation-10.a0fadd65.svg";